
const rootRoutes = {
    root: "/",
    login: "/auth/login",
};

const adminRoutes = {
    adminDashboard: "/dashboard",
    blog: "/blog",
    addBlog: "/add-blog",
    editBlog: "/editblog/:blog_id",
    viewBlog: "/viewblog/:id",
    contactUs: "/contact-us",
    events: "/events",

    metaInfo: "/meta-info",
    addMetaInfo: "/add-meta-info",

    userList: "/user_list",
    addUser: "/add_user",
    editUser: "/edit_user",


    addFaq: "/add-faq",
    faq: "/faq",
    gotsCertificate: "/generate-gots",
    newsletters: "/news_letter",
    newsList: "/news",
    logs_list: "/logs_list",

    addNews: "/add-news",
    editNews: "/edit-news/:news_id",
};

export const componentRoutes = {
    ...rootRoutes,
    ...adminRoutes,
};